import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ButtonFormSubmit } from "./ButtonFormSubmit";
import { ButtonModalClose } from "./ButtonModalClose";
import React from "react";
import Button from "react-bootstrap/Button";

export const ButtonModalFormSaveClose = ({
  saveName,
  formSave,
  loading,
  closeName = "Close",
  close = null,
  saveButtonClassName = "w-100 h-100",
  closeButtonClassName = "w-100",
}) => {
  const displaySelection = () => {
    if (close !== null)
      return (
        <Modal.Footer className={"mb-0 pb-0"}>
          <Container fluid>
            <Row className="mb-3 align-content-center">
              <Col>
                <ButtonModalClose
                  className={closeButtonClassName}
                  close={close}
                  buttonText={closeName}
                />
              </Col>
              <Col>
                <ButtonFormSubmit
                  formOnSubmit={formSave}
                  buttonText={saveName}
                  disableButton={loading}
                  className={saveButtonClassName}
                />
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      );

    return (
      <Modal.Footer className={"mb-0 pb-0"}>
        <Container fluid>
          <Row className="mb-3 align-content-center">
            <Col>
              <ButtonModalClose close={close} buttonText={"Close"} />
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    );
  };

  return displaySelection();
};

export const ButtonModalOnClickClose = ({
  funcButtonName,
  loading,
  onClickFunc,
  close = null,
  closeName = "Close",
  funcButtonClassName = "w-100",
  closeButtonClassName = "w-100",
}) => {
  const displaySelection = () => {
    if (close !== null)
      return (
        <Modal.Footer className={"mb-0 pb-0"}>
          <Container fluid>
            <Row className="mb-3 align-content-center">
              <Col>
                <ButtonModalClose
                  className={closeButtonClassName}
                  close={close}
                  buttonText={closeName}
                />
              </Col>
              <Col>
                <Button
                  variant="outline-offblack"
                  className={funcButtonClassName}
                  onClick={onClickFunc}
                  disabled={loading}
                >
                  {funcButtonName}
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      );

    return (
      <Modal.Footer className={"mb-0 pb-0"}>
        <Container fluid>
          <Row className="mb-3 align-content-center">
            <Col>
              <ButtonModalClose close={close} buttonText={"Close"} />
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    );
  };

  return displaySelection();
};

export const ButtonModalFormSaveCloseThirdAction = ({
  saveName,
  formSave,
  loading,
  thirdActionName,
  thirdActionAction,
  thirdActionClassName = "w-100 h-100",
  closeName = "Close",
  close = null,
  saveButtonClassName = "w-100 h-100",
  closeButtonClassName = "w-100",
}) => {
  const displaySelection = () => {
    if (close !== null)
      return (
        <Modal.Footer className={"mb-0 pb-0"}>
          <Container fluid>
            <Row className="mb-3 align-content-center">
              <Col>
                <ButtonModalClose
                  className={closeButtonClassName}
                  close={close}
                  buttonText={closeName}
                />
              </Col>
              <Col>
                <Button
                  onClick={thirdActionAction}
                  disableButton={loading}
                  variant={"danger"}
                  className={thirdActionClassName}
                >
                  {thirdActionName}
                </Button>
              </Col>
              <Col>
                <ButtonFormSubmit
                  formOnSubmit={formSave}
                  buttonText={saveName}
                  disableButton={loading}
                  className={saveButtonClassName}
                />
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      );

    return (
      <Modal.Footer className={"mb-0 pb-0"}>
        <Container fluid>
          <Row className="mb-3 align-content-center">
            <Col>
              <ButtonModalClose close={close} buttonText={"Close"} />
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    );
  };

  return displaySelection();
};
